import React, { useState } from "react";
import { Text, Input, Img } from "..";
import axios from 'axios';
import { Link } from "react-router-dom";
import './footer.css'
import WashtaLogo from "../../pages/Home1/Home1Page/washta-logo.png";
// import WashtaAppIcon from "./washta-app-icon.png";
// import WashtaBrandIcon from "./washta-brand-icon.png";
// import ExteriorWash from "./exterior-wash.jpg";
// import FullDetailing from "./full-detailing.png";
// import CeramicCoating from "./ceramic-coating.jpg";
import { CiMail } from "react-icons/ci";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { FaRegFileAlt } from "react-icons/fa";
export default function Footer({ ...props }) {
  const [userEmail, setuserEmail] = useState('');
  const [response, setResponse] = useState(null);
  const handleInputChange = (event) => {
    setuserEmail(event.target.value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('https://backend.washta.com/api/email', { userEmail:userEmail });
      console.log('Response:', response.data);
      // Agar response me koi specific data hai jo aap handle karna chahte hain, toh yaha par handle karein.
    } catch (error) {
      console.error('Error posting email:', error);
      // Agar koi error aata hai toh use handle karein.
    }
  };
  return (
    // <footer  style={{background:'#6b5fe4',paddingTop:'25px',paddingBottom:'25px'}} {...props}>
    //   <div className="container-xs flex flex-col gap-[84px] md:gap-[63px] md:p-5 sm:gap-[42px] md:pl-[0px] md:pr-[0px]" style={{width:'90%'}}>
    //     <div className="flex items-start justify-between gap-2 md:flex-col">
    //       <div className="flex w-[28%] flex-col gap-5 md:w-full ">
    //         <img src={Footerimg} alt="footerlogo" className="w-[210px]" />
    //         <Text size="20px" as="p" >
    //           If you don&#39;t find an answer to your question, contact us, and our team will get in touch with you.
    //         </Text>
    //         <div className="flex justify-start gap-2 items-center mt-[-2em]">
    //         <MdOutlineMail  className="text-[white] text-[1.2em]"/>
    //       <p className="text-[#ffffffbf]"> info@washta.com</p> 
    //         </div>
    //       </div>
    //       <div className="flex flex-col gap-3.5">
    //         <Text size="md" as="p" className="!font-generalsans tracking-[-1.00px] !text-white-A700">
    //           Links
    //         </Text>
            
    //         <Link to='/'>
    //         <a  rel="noreferrer">
    //           <Text size="20px" as="p">Home</Text>
    //         </a>
    //         </Link>
    //         <Link to='/become-a-partner'>
    //         <a  rel="noreferrer">
    //           <Text size="20px" as="p">Become A Partner</Text>
    //         </a>
    //         </Link>
    //         <Link to='/sign-in'>
    //         <a  rel="noreferrer">
    //           <Text size="20px" as="p">Sign in</Text>
    //         </a>
    //         </Link>
    //         <Link to='/become-a-seller'>
    //         <a  rel="noreferrer">
    //           <Text size="20px" as="p">Sign up</Text>
    //         </a>
    //         </Link>
    //       </div>
    //       <div className="footerclassName">
    //         {/* <Text size="20px" as="p" className="text-center" > */}
    //           <p className="paragraphp">
    //           Join our newsletter to stay up to date on features and releases.
    //           </p>
             
    //         {/* </Text> */}
          
    
    //       </div>
    //     </div>
    //     <div className="flex items-center justify-between gap-5 md:flex-col">
    //     <p className="paragraphp">
    //     © 2025 Washta. All rights reserved
    //     Powered By Bigwals
    //           </p>
    //       {/* <Text size="20px" as="p" className="self-end">
    //         © 2024 Washta. All rights reserved.
    //       </Text> */}
    //       <ul className="flex flex-wrap items-center gap-[25px]  ">
    //         <li>
    //         <p className="paragraphp lipara">
    //         <NavLink to='/PrivacyPolicy'> Privacy Policy </NavLink> 
    //           </p>
    //           {/* <a href="#" className="self-end">
    //             <Text size="20px" as="p">Privacy Policy</Text>
    //           </a> */}
    //         </li>
    //         <li>
    //         <p className="paragraphp lipara">
    //        <NavLink to='/TermsOfUse'> Terms of Use </NavLink>
    //           </p>
    //           {/* <a href="#" className="self-start">
    //             <Text size="20px" as="p">Terms of Service</Text>
    //           </a> */}
    //         </li>
    //         <li>
    //         <p className="paragraphp lipara">
    //         Cookies Settings
    //           </p>
    //           {/* <a href="#" className="self-end">
    //             <Text size="20px" as="p">Cookies Settings</Text>
    //           </a> */}
    //         </li>
    //       </ul>
    //     </div>
    //   </div>
    // </footer>
     <footer>
      <div className="ft-wrap">
        <div className="ft-top">
          <div className="ft-brand">
            <a href="/" className="ft-logo" aria-label="Washta">
              <img src={WashtaLogo} alt="Washta" style={{ height: "22px" }} />
            </a>
            <p className="ft-tagline">Platform only · We connect customers with stationed providers</p>
            <span className="ft-badge">
              <span className="ft-dot" />
              Dubai &amp; Abu Dhabi
            </span>
          </div>
    
          <div className="ft-right">
            <div className="ft-col">
              <span className="ft-col-title">Contact</span>
              <a href="mailto:info@washta.com">
                <CiMail /> info@washta.com
              </a>
            </div>
            <div className="ft-col">
              <span className="ft-col-title">Legal</span>
              <a href="/PrivacyPolicy"><IoShieldCheckmarkOutline /> Privacy Policy</a>
              <a href="/TermsOfUse"><FaRegFileAlt /> Terms of Use</a>
            </div>
          </div>
        </div>
    
        <div className="ft-bottom">
          <span className="ft-copy">© 2026 Washta. All rights reserved.</span>
          <span className="ft-powered" style={{display:'flex'}}>
            Powered by <a href="https://bigwals.com" target="_blank" rel="noopener noreferrer" style={{color:'#6b5fe4'}}>Bigwals</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
